module.exports = __webpack_public_path__ + "img/m-item08.ff3c05f.png";